class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 800);
        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', (event) => {
            if (window.innerWidth < 992) return;
            this.debouncedOnSubmit(event);
        });
    }

    static setListeners() {
        window.addEventListener('popstate', (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl)
                ? FacetFiltersForm.renderSectionFromCache(filterDataUrl)
                : FacetFiltersForm.renderSectionFromFetch(url);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url) {
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderFiltersSidebar(html);
                document.dispatchEvent(new CustomEvent('facets:rendered'));
            });
    }

    static renderSectionFromCache(filterDataUrl) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderFiltersSidebar(html);
        document.dispatchEvent(new CustomEvent('facets:rendered'));
    }

    static renderProductGridContainer(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = parsed.getElementById('ProductGridContainer');
        const currentGrid = document.getElementById('ProductGridContainer');
        if (newGrid && currentGrid) currentGrid.innerHTML = newGrid.innerHTML;
    }

    static renderFiltersSidebar(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newSidebar = parsed.getElementById('main-collection-filters');
        const currentSidebar = document.getElementById('main-collection-filters');
        if (newSidebar && currentSidebar) currentSidebar.innerHTML = newSidebar.innerHTML;
    }

    static updateURLHash(searchParams) {
        history.pushState(
            { searchParams },
            '',
            `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
        );
    }

    static getSections() {
        return [{ section: document.getElementById('product-grid').dataset.id }];
    }

    createSearchParams(form) {
        return new URLSearchParams(new FormData(form)).toString();
    }

    onSubmitForm(searchParams) {
        FacetFiltersForm.renderPage(searchParams);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const forms = [];
        document.querySelectorAll('facet-filters-form form').forEach((form) => {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm') {
                forms.push(this.createSearchParams(form));
            }
        });
        this.onSubmitForm(forms.join('&'));
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        const url =
            event.currentTarget.href.indexOf('?') === -1
                ? ''
                : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach((element) => {
            element.addEventListener('change', this.onRangeChange.bind(this));
            element.addEventListener('keydown', this.onKeyDown.bind(this));
        });
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    onKeyDown(event) {
        if (event.metaKey) return;
        const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
        if (!event.key.match(pattern)) event.preventDefault();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('data-min', 0);
        if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('data-min'));
        const max = Number(input.getAttribute('data-max'));
        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
    }
}

customElements.define('facet-remove', FacetRemove);